import { render, staticRenderFns } from "./StudentsSemesterEligibiltyDisability.vue?vue&type=template&id=4e485ee2&scoped=true&"
import script from "./StudentsSemesterEligibiltyDisability.vue?vue&type=script&lang=js&"
export * from "./StudentsSemesterEligibiltyDisability.vue?vue&type=script&lang=js&"
import style0 from "./StudentsSemesterEligibiltyDisability.vue?vue&type=style&index=0&id=4e485ee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e485ee2",
  null
  
)

export default component.exports